import React, { useState } from "react";
import NewTripForm2 from "./NewTripForm2";
import NewTripForm3 from "./NewTripForm3";
import NewTripForm4 from "./NewTripForm4";
import NewTripForm5 from "./NewTripForm5";
import Confirm from "./Confirm";
import TitleBar from "../../../components/TitleBar";
import Alert from '@mui/material/Alert';
import Grid from "@mui/material/Grid";

function NewTripForm1({ tripId, vtr_nbr, permitNbr, returnedErrors, handleSubmit }) {
  const [step, setStep] = useState(1);
  const [tripid, setTripId] = useState(tripId);
  const [speciescd, setSpecies] = useState("");
  const [gearType, setGearType] = useState("");
  const [portcd, setPortCD] = useState({});
  const [mgmtArea, setMgmtArea] = useState("false");
  const [neMultiFlg, setNeMultiFlg] = useState("false");
  const [brdstckArea, setBrdstckArea] = useState({
    GOMDA: false,
    SNEDA: false,
    INSHORE: false,
    OFFSHORE: false,
  });

  const values = {
    tripid,
    vtr_nbr,
    permitNbr,
    speciescd,
    gearType,
    portcd,
    mgmtArea,
    neMultiFlg,
    brdstckArea,
    setStep,
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const goToStep = (step) => {
    setStep(step);
  };

  const handleChange = (input) => (event, reason) => {
    const { name = "", value, checked } = event.target;

    if (input === "brdstckArea") setBrdstckArea({ ...brdstckArea, [name]: checked });
    else if (input === "port") {
      if (reason) {
        if (reason.hasOwnProperty("id") && reason.hasOwnProperty("label")) {
          setPortCD({ id: reason.id, name: reason.label, state: reason.state });
        }
      } else {
        setPortCD({});
      }
    } else if (input === "speciescd") {
      setSpecies(value);
    } else if (input === "gearType") {
      setGearType(value);
    } else if (input === "trip_id") {
      setTripId(value);
    } else if (input === "mgmtArea") {
      setMgmtArea(value);
    } else if (input === "neMultiFlg") {
      setNeMultiFlg(value);
    }
  };

  const handleConfirm = (values) => {
    handleSubmit(values);
  };

  return (
    <>
      <TitleBar title="DAS Open Trip Hail" />
      <Grid item xs={12} md={7}>
        {returnedErrors.onSubmitted && (
          <Alert severity="error">{returnedErrors.onSubmitted}</Alert>
        )}
      </Grid>
      <div style={{ width: "100%" }}>
        {
          {
            1: (
              <NewTripForm2
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            2: (
              <NewTripForm3
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            3: (
              <NewTripForm4
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            4: (
              <NewTripForm5
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            5: (
              <Confirm
                prevStep={prevStep}
                goToStep={goToStep}
                handleConfirm={handleConfirm}
                values={values}
              />
            ),
          }[step]
        }
      </div>
    </>
  );
}

export default NewTripForm1;
